import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_TIMESHEET } from '../../data.const';
import {
  retrieveTimesheetListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteTimesheetEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_TIMESHEET),
    map(({ payload: { ids, isCestino, ...rest } }: any) => ({
      body: {
        ids,
        isCestino,
      },
      listBody: { ...rest, isCestino },
    })),
    tap(p => console.log(`[epic ${DELETE_TIMESHEET}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ timesheetLoader: true })),
        defer(() =>
          from(
            request({ path: `timesheet`, method: httpMethods.DELETE, body })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            // tap(p => console.log(`[epic ${DELETE_TIMESHEET}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(() => of(retrieveTimesheetListAction(listBody))),
            catchError(err => {
              console.error(`[epic ${DELETE_TIMESHEET}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ timesheetLoader: false }))
      );
    })
  );

export default deleteTimesheetEpic;
